export default "__VITE_ASSET__932bacc1__"